"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _row = _interopRequireDefault(require("../../../core/row"));
var _fullWidth = _interopRequireDefault(require("../../../root/full-width"));
var _contacts = _interopRequireDefault(require("./contacts"));
var _receivingEntries = _interopRequireDefault(require("./receiving-entries"));
var _additionalInfo = _interopRequireDefault(require("./additional-info"));
var _entryFees = _interopRequireDefault(require("./entry-fees"));
var _entryLimits = _interopRequireDefault(require("./entry-limits"));
var _yearBookEntry = _interopRequireDefault(require("./year-book-entry"));
var _specials = _interopRequireDefault(require("./specials"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _changeStatusButton = _interopRequireDefault(require("../shared-components/application-actions/changeStatusButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  isActioning: false,
  message: null
};
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to this application");
var _ref2 = /*#__PURE__*/_react.default.createElement(_alert.default, null, "This application has been submitted for the year book and is awaiting approval");
var _ref3 = /*#__PURE__*/_react.default.createElement(_alert.default, null, "This application has been accepted for the year book");
var _ref4 = /*#__PURE__*/_react.default.createElement(_alert.default, null, "This application is waiting for completed year book information - please press submit button at bottom of page when ready");
var _ref5 = /*#__PURE__*/_react.default.createElement("br", null);
class ApplicationEdit extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_setValue", (value, field) => {
      this.props.setValue(this.props.applicationByID.id, value, field);
    });
    _defineProperty(this, "_onSubmitYearBookEntry", () => {
      if (this.state.isActioning) return;
      this.setState({
        isAction: true
      });
      return this.props.onSubmitYearBookEntry(this.props.applicationByID.id).then(results => {
        if (results.message) this.setState({
          message: results.message
        });
        return this.setState({
          isActioning: false
        });
      });
    });
    _defineProperty(this, "_onCloseCancel", () => {
      this.setState(initialState);
    });
  }
  render() {
    const application = this.props.applicationByID;
    if (!application || !application.id) return null;
    if (!application.isAdministratedByUser) return _ref;
    if (application.calendarID !== +this.props.match.params.yearID) return /*#__PURE__*/_react.default.createElement("p", null, "There is no such application in ", this.props.match.params.yearID);
    return /*#__PURE__*/_react.default.createElement(_fullWidth.default, null, !this.state.message ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onCloseCancel
      }, "Close"),
      onClose: this.props._onCloseCancel
    }, this.state.message), application.applicationStatusRef === 'SUBM' ? _ref2 : application.applicationStatusRef === 'COMP' ? _ref3 : application.applicationStatusRef === 'REQ' ? _ref4 : null, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      lg: 6
    }, /*#__PURE__*/_react.default.createElement(_yearBookEntry.default, {
      application: application
    }), /*#__PURE__*/_react.default.createElement(_contacts.default, {
      application: application,
      setValue: this._setValue
    }), /*#__PURE__*/_react.default.createElement(_specials.default, {
      userIsCalendarOfficer: this.props.userIsCalendarOfficer,
      application: application
    })), /*#__PURE__*/_react.default.createElement(_col.default, {
      lg: 6
    }, /*#__PURE__*/_react.default.createElement(_receivingEntries.default, {
      application: application,
      setValue: this._setValue
    }), /*#__PURE__*/_react.default.createElement(_entryFees.default, {
      application: application
    }), /*#__PURE__*/_react.default.createElement(_entryLimits.default, {
      application: application,
      setValue: this._setValue
    }), /*#__PURE__*/_react.default.createElement(_additionalInfo.default, {
      application: application,
      setValue: this._setValue
    }), application.applicationStatusRef !== 'REQ' ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      block: true,
      type: "primary",
      onClick: this._onSubmitYearBookEntry
    }, "Submit Yearbook Entry"), _ref5, !this.props.userIsCalendarOfficer ? null : /*#__PURE__*/_react.default.createElement(_changeStatusButton.default, {
      block: true,
      type: "primary",
      application: application,
      userIsCalendarOfficer: this.props.userIsCalendarOfficer
    }))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref6 = _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
  id: true,
  isAdministratedByUser: true,
  calendarID: true,
  applicationStatusRef: true
}, _contacts.default.partialQueries.Application), _receivingEntries.default.partialQueries.Application), _entryFees.default.partialQueries.Application), _additionalInfo.default.partialQueries.Application), _entryLimits.default.partialQueries.Application), _yearBookEntry.default.partialQueries.Application), _specials.default.partialQueries.Application), _changeStatusButton.default.partialQueries.Application);
var _default = exports.default = (0, _reactBicycle.connect)(ApplicationEdit, props => ({
  userIsCalendarOfficer: true,
  ["applicationByID(applicationID:" + JSON.stringify(+props.match.params.appid) + ")"]: _ref6
}), (client, props) => ({
  setValue(id, value, field) {
    return client.update('Application.set', {
      id,
      value,
      field
    });
  },
  onSubmitYearBookEntry(applicationID) {
    return client.update('Application.submitYearbookEntry', {
      applicationID
    });
  }
}));